// extracted by mini-css-extract-plugin
export default {"container":"ThankYou_container__Qd3iU","h1":"ThankYou_h1__s+NTC","p":"ThankYou_p__Rt4DH"};